/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { Text } from 'react-native';

import { scale } from '@components/frame';
import { localTime } from '@helpers';
import { font } from '@styles/fonts';

// const useForceUpdate = () => {
//   const [value, setValue] = useState(0); // integer state
//   return () => setValue((value) => ++value); // update the state to force render
// };

export default ({ C, timeOffset }) => {
  // const forceUpdate = useForceUpdate();
  const time = localTime().add(timeOffset, 'milliseconds').format('HH:mm:ss.S');

  // useEffect(() => {
  //   let interval = setInterval(() => {
  //     forceUpdate();
  //   }, 100);
  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, []);

  return (
    <Text
      style={[
        {
          color: C('Label/Dark/Primary'),
          marginTop: scale(5),
        },
        font['Large Title'],
      ]}
    >
      {time}
    </Text>
  );
};
